// 品牌管理
const map = {
  cfdaList: () => import('@/views/brand/CFDAList'),
  cfdaDetail: () => import('@/views/brand/CFDADetail'),
  storePrivateBrand: () => import('@/views/brand/StorePrivateBrand'),
  generalCredit: () => import('@/views/brand/GeneralCredit'),
  traceBrand: () => import('@/views/brand/TraceBrand'),
  brandAuthorizationInformation: () => import('@/views/brand/BrandAuthorizationInformation'),
  cFDAManaDetail: () => import('@/views/brand/CFDAManaDetail') // 商品对应cfda详情
}

export default map
